import { initGlobalState, MicroAppStateActions } from 'qiankun';

// 微应用通信 定义全局状态，并返回通信方法
const state = {
  dialogMarkingVisible: false,
  id: null,
  deptGroupName: null,
  workAreaName: null,
  app: null,
  userId: null,
}
const actions : MicroAppStateActions = initGlobalState(state);
actions.setGlobalState({
  dialogMarkingVisible: false,
  id: null,
  deptGroupName: null,
  workAreaName: null,
  app: null,
  userId: null,
})

actions.onGlobalStateChange((state) => {
  console.log('-------------state监听：',state)
})


export default actions;
